import { useToastStore, type ToastVariant } from "@/stores/toast-store";

const DEFAULT_DURATION_MS = 4500;

function emit(
  variant: ToastVariant,
  message: string,
  options?: { durationMs?: number | null }
): string {
  // Skip during SSR
  if (typeof window === "undefined") return "";
  return useToastStore.getState().add({
    message,
    variant,
    durationMs:
      options?.durationMs === undefined ? DEFAULT_DURATION_MS : options.durationMs,
  });
}

export const toast = {
  success: (message: string, options?: { durationMs?: number | null }) =>
    emit("success", message, options),
  error: (message: string, options?: { durationMs?: number | null }) =>
    emit("error", message, options),
  info: (message: string, options?: { durationMs?: number | null }) =>
    emit("info", message, options),
  dismiss: (id: string) => useToastStore.getState().dismiss(id),
  clear: () => useToastStore.getState().clear(),
};
